/**
 * This Turbo helper solves the situation when the user navigates
 * from the Statistics page to another page in the main menu
 * and then clicks on the browser back button.

 * chart_and_control_set.js L10 writes the url for Statistics to the history twice.
 * Turbo is thus unable to load the Statistics page
 * when the browser back button is clicked,
 * it only responds on the third click.
*/

const refreshStatsPage = () => {

  let statsPageUrl = '';
  let previousSearchParams =  null;
  let currentSearchParams =  null;


  /* Run url change only once */
  window.addEventListener('chart-and-control-set:history-change', (e) => {
    const url = new URL(window.location.href);

    deletePreviousSearchParams(url)
    addNewSearchParams(e, url);

    /* If the current search params are different from the previous ones,
       we will replace history with correct url */
    if (currentSearchParams !== previousSearchParams) {
      history.replaceState(history.state, "", statsPageUrl);
      previousSearchParams = currentSearchParams;
    }
  })

  /* Strip the previous search params from the URL */
  const deletePreviousSearchParams = (url) => {
    previousSearchParams = `?${url.searchParams.toString()}`;

    const params = url.searchParams;

    const keys = [...params.keys()];
    for (const key of keys) {
      params.delete(key)
    }
  };

  /* Add new search params to the URL from event detail */
  const addNewSearchParams = (e, url) => {
    currentSearchParams = e.detail;
    url.search = new URLSearchParams(e.detail);
    statsPageUrl = url.toString();
  };
}

export default refreshStatsPage;